module.exports = __webpack_public_path__ + "img/zygmuntowski.de3b0407.jpg";